module.exports = __webpack_public_path__ + "static/pizza24-8dd778173f6ab0772e9e7bbbfb602797.webp";